import ConditionalLinkWrapper from '@atoms/ConditionalLinkWrapper/ConditionalLinkWrapper';
import { ILink } from '@models/ILink';
import classNames from 'classnames';

interface Props {
  readonly bullets: (string | ILink | null | undefined)[];
  readonly textSize?: string;
  readonly textColour?: string;
  readonly className?: string;
  readonly bulletClasses?: string;
  readonly noWrap?: boolean;
  readonly dataTestId?: string;
}

const Bullets = ({
  bullets,
  textSize = 'body-three',
  textColour = 'text-black-100 dark:text-white',
  className,
  bulletClasses,
  noWrap = true,
  dataTestId,
}: Props) => {
  const displayedBullets = bullets.filter(
    (bullet) =>
      (typeof bullet === 'string' && !!bullet) ||
      (typeof bullet === 'object' && !!bullet?.name)
  );
  if (!displayedBullets.length) return null;

  return (
    <div
      className={classNames('flex flex-wrap items-center', className)}
      data-testid={dataTestId}
    >
      {displayedBullets.map((bullet, index) => (
        <span
          key={typeof bullet === 'string' ? bullet : bullet?.name}
          className={classNames(
            { 'whitespace-nowrap': noWrap },
            'pr-2',
            textColour,
            textSize,
            bulletClasses
          )}
        >
          {index !== 0 && (
            <span className="mr-2 text-black-100 dark:text-yellow">•</span>
          )}

          {typeof bullet === 'object' && (
            <ConditionalLinkWrapper link={bullet} hasHoverUnderline>
              {bullet?.name}
            </ConditionalLinkWrapper>
          )}

          {typeof bullet === 'string' && bullet}
        </span>
      ))}
    </div>
  );
};

export default Bullets;
